const { forEach } = require('lodash');

class SignupService {
    constructor($rootScope, $q, Restangular, sessionStorage, loginService, shopperService, analytics, settings) {
        this._api = Restangular.one('signup');
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.sessionStorage = sessionStorage;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.analytics = analytics;
        this.settings = settings;

        this.businessTypes = this.getBusinessTypes();
    }

    signup(args) {
        const signupPromise = this._api.doPOST(args);

        const shopperPromise = signupPromise.then(signupResult => (signupResult.Success
            ? this.shopperService.getCurrentShopper()
            : null));

        return this.$q.all([signupPromise, shopperPromise])
            .then(([signupResult]) => {
                if (signupResult.Success) {
                    this.redirectToAgentUrl = signupResult.RedirectToAgentUrl;
                    this.analytics.push({ data: { event: 'signup' } });
                    this.loginService.onLogin(signupResult.LoginModel);
                    this.$rootScope.$broadcast('signup:success');
                    // flag to push login and signup user detail to analytics
                    this.sessionStorage.set('shouldTrackSignupEvent', true);
                    this.sessionStorage.set('shouldTrackLoginEvent', true);
                }

                return signupResult;
            });
    }

    getBusinessTypes() {
        if (this.settings.b2B.businessTypeCategoryMapping === null) {
            return [];
        }

        const businessTypes = [];
        const settingLines = this.settings.b2B.businessTypeCategoryMapping.split(/\r\n|\r|\n/g);
        forEach(settingLines, (line) => {
            const businessTypeData = line.split(';');
            if (businessTypeData && businessTypeData.length >= 1) {
                businessTypes.push(businessTypeData[0].trim());
            }
        });

        return businessTypes.sort();
    }
}

SignupService.$inject = ['$rootScope', '$q', 'Restangular', 'SessionStorageWrapper', 'LoginService', 'ShopperService', 'AnalyticsService', 'Settings'];

module.exports = { SignupService };



// WEBPACK FOOTER //
// ./src/auth/signup/signup.service.js